import { useCallback, useRef } from 'react';

export const useDebounce = () => {
  const debounceRef = useRef<any>(null);

  const debounce = useCallback(
    (callback: () => void, timeout: number) => {
      if (debounceRef.current) {
        debounceRef.current = null;
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
        callback();
        clearTimeout(debounceRef?.current);
      }, timeout);
    },
    [debounceRef]
  );

  return {
    debounceRef,
    debounce
  };
};
